import styled from '@emotion/styled';
import { Box, Paper } from '@mui/material';

export const ToiletCounterWrapperBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  overflow: 'hidden',
  border: '1px solid #ddd',
  width: 200,
  height: '40px',
  justifyContent: 'center'
});

export const ToiletCountItemBox = styled(Box)({
  flex: 1,
  backgroundColor: '#c0b6e0',
  borderRadius: 0,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
